<template>
  <div class="modal fade" id="delete-alert" role="dialog" @click="$emit('close')">
    <div class="modal-dialog" @click.stop>
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header bg-color-info">
          <button type="button" class="close close-btn" data-dismiss="modal" @click="$emit('close')"> &times;</button>
        </div>
        <div class="modal-body">
          <span>このアイテムを削除してもよろしいですか？</span>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning" data-dismiss="modal" @click="$emit('confirm')" ref="deletebutton">OK</button>
          <button type="button" class="btn" data-dismiss="modal" @click="$emit('close')">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    $('#delete-alert').modal('show')
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalDeleteAlert.vue